import PropTypes from 'prop-types'
import React from 'react'

import UpsaleCardWide from 'components/_special/UpsaleCardWide'
import { GOODS_TYPES } from 'constants/sales'
import useInViewCommon from 'hooks/useInViewCommon'
import useSaleCard from 'hooks/useSaleCard'
import { BoxBase } from 'styles/components/layout'

const CartSaleWideContainer = ({ productType, className }) => {
  const [ref, inView] = useInViewCommon()
  const { commonUpsaleProps, dict } = useSaleCard({
    productType,
    isSubscription: false,
  })
  const containerProps =
    productType !== GOODS_TYPES.biome ? { overflow: 'hidden' } : {}

  const isZeroPrice = commonUpsaleProps.costValue === 0 || commonUpsaleProps.costRealValue === 0

  return (
    <div {...{ className }} ref={ref}>
      <BoxBase {...containerProps}>
        <UpsaleCardWide
          {...{
            ...commonUpsaleProps,
            isVisible: inView,
            title: dict.kits[productType].title_long,
            description: dict.kits[productType].description,
            productType,
            isDisabled: isZeroPrice,
            buttonTitle: isZeroPrice ? dict.buttons.out_of_stock : commonUpsaleProps.buttonTitle,
            buttonLinkTitle: isZeroPrice ? dict.buttons.out_of_stock : commonUpsaleProps.buttonLinkTitle,
          }}
        />
      </BoxBase>
    </div>
  )
}

CartSaleWideContainer.propTypes = {
  className: PropTypes.string,
  productType: PropTypes.oneOf([
    GOODS_TYPES.dna,
    GOODS_TYPES.biome,
    GOODS_TYPES.wgs,
  ]).isRequired,
}

CartSaleWideContainer.defaultProps = {
  className: '',
}

export default React.memo(CartSaleWideContainer)
